module.exports = __webpack_public_path__ + "162b2cd9f076e080c7807231596ea790.pdf";